import {
  BaseTagValueStructuredTableColumn,
  GenericStructuredTableColumn,
} from 'notebook/structured-tables/StructuredTableConstants';
import {BaseTypedValueType, TableColumnType, TypedValue} from 'notebook/tables/TableConstants';
import {
  BioentityLinkSchemaFieldTypedValue,
  BioentityTypedValue,
} from 'notebook/tables/typed-values/TypedValueTypes';
import {FieldType} from 'schemas/fields/SchemaFieldConstants';

/**
 * Perform any translations between the source typed value and destination column's desired type. Currently, this function only
 * translates from BaseTypedValueType.BIOENTITY to FieldType.BIOENTITY_LINK typed values but there are some other translations
 * we could add.
 *
 * Longer term, we should incorporate this function into general typed value resolution.
 *
 * @param value The source cell value.
 * @param column The destination cell's column.
 */
export default function coerceMappedSourceValueToDestinationColumn(
  value: TypedValue,
  column: GenericStructuredTableColumn<unknown>
): TypedValue {
  if (
    column.columnType === TableColumnType.TAG_VALUE &&
    (column as BaseTagValueStructuredTableColumn<unknown>).schemaFieldType === FieldType.BIOENTITY_LINK &&
    value.type === BaseTypedValueType.BIOENTITY
  ) {
    return convertBioentityTypedValueToBioentityLinkSchemaFieldTypedValue(value);
  } else {
    return value;
  }
}

/**
 * Translates a BioentityTypedValue into a BioentityLinkSchemaFieldTypedValue. The resulting targetFiles entries
 * will have their url fields set to the empty string.
 *
 * @param value the typed value to convert.
 */
function convertBioentityTypedValueToBioentityLinkSchemaFieldTypedValue(
  value: BioentityTypedValue
): BioentityLinkSchemaFieldTypedValue {
  return {
    type: FieldType.BIOENTITY_LINK,
    targetFiles: [
      {
        id: value.bioentitySummary.id,
        name: value.bioentitySummary.displayLabel ?? value.bioentitySummary.name,
        url: '',
      },
    ],
    value: null,
  };
}
